import { SectionsService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const sectionQueryKey = (id: string) => {
  return ["section", id] as const;
};

function useSection(id: string) {
  return useQuery({
    queryKey: sectionQueryKey(id),
    queryFn: () => SectionsService.getSectionById({ id }),
  });
}

export { sectionQueryKey, useSection };
